export default __webpack_public_path__ + "static/media/bb7.1566ccfe.png";